import FormField from 'components/FormField';
import { useTranslate } from '@tolgee/react';
import { FV } from './share';
import { InputNumber } from 'antd';
import { DisabledProps } from 'views/Aide/Scenario/TaskForm/share';

function MultiPackThreshold({ disabled }: DisabledProps) {
  const { t } = useTranslate();

  const label = t('activity_threshold');

  const placeholder = t('department.请输入x', { x: label });

  return (
    <FormField<FV['multiPackThreshold']>
      name="multiPackThreshold"
      required
      label={label}
      validate={(value) => (value ? undefined : placeholder)}
    >
      {({ field: { value, onChange, onBlur } }) => {
        return (
          <InputNumber
            className="!w-[160px]"
            disabled={disabled}
            placeholder={placeholder}
            addonAfter={t('件')}
            precision={0}
            min={1}
            max={999}
            value={value}
            onChange={(value) => onChange(value || undefined)}
            onBlur={onBlur}
          />
        );
      }}
    </FormField>
  );
}

export default MultiPackThreshold;
